/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileWithRelations } from '../../models/file-with-relations';

export interface AdminUploadPictures$Params {
  itemId?: string;
  inventoryId: string;
  isPublic?: boolean;
  order?: number;
  authorId?: string;
  title?: string;
  titleEN?: string;
  description?: string;
  descriptionEN?: string;
  copyright?: string;
  copyrightEN?: string;
  notesInternal?: string;
  
    /**
     * Request body for multipart/form-data based file upload
     */
    body: {
'file'?: Blob;
}
}

export function adminUploadPictures(http: HttpClient, rootUrl: string, params: AdminUploadPictures$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminUploadPictures.PATH, 'post');
  if (params) {
    rb.query('itemId', params.itemId, {});
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('isPublic', params.isPublic, {});
    rb.query('order', params.order, {});
    rb.query('authorId', params.authorId, {});
    rb.query('title', params.title, {});
    rb.query('titleEN', params.titleEN, {});
    rb.query('description', params.description, {});
    rb.query('descriptionEN', params.descriptionEN, {});
    rb.query('copyright', params.copyright, {});
    rb.query('copyrightEN', params.copyrightEN, {});
    rb.query('notesInternal', params.notesInternal, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FileWithRelations>>;
    })
  );
}

adminUploadPictures.PATH = '/admin/items/pictures';
